import HttpEntityClient from '@123/druid/dist/Components/Http/HttpEntityClient';
import {injectable} from '@123/druid/dist/Framework/Decorators/Inject';
import {newsItemSchema, type NewsItem} from '@Module/News/Schema/NewsItem';

@injectable()
export default class NewsService {
    constructor(private entityClient: HttpEntityClient = new HttpEntityClient()) {}

    public getNewsItem(newsId: number): Promise<NewsItem> {
        return this.entityClient.get('/news/news-' + newsId + '.html', newsItemSchema);
    }
}
